import {useOpenModal} from '@/components/Modal/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import ImportArchitecturePlanDlg from '@/pages/MainPage/panes/ImportArchitecturePlan/ImportArchitecturePlanDlg.jsx'

export default () => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const {mapTypeCode, prjId, sVer} = map.data

    if ('SA_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => openModal(
        <ImportArchitecturePlanDlg param={{prjId, sVer}} />
    )

    return {
        label: '导入需求架构',
        onClick,
    }
}
